export const defaultColumns = [
  {
    groupName: "bundle",
    columns: [
      "nominalTorque",
      // "nominalTorqueUtilization",
      "nominalSpeed",
      // "nominalSpeedUtilization",
      "bundleInertia",
      "inertiaRatio",
      "length"
    ],
    deploy: true
  },
  {
    groupName: "drive",
    columns: [
      "driveReference",
      "driveRangeOfProduct",
      "driveComponentType",
      "switchingFreq",
      "format",
      "current",
      "driveSupplyVoltage",
      "nbPhases",
      "interface",
      "nominalPower",
      "lineCurrent"
    ],
    deploy: false
  },
  {
    groupName: "motor",
    columns: [
      "motorReference",
      "motorComponentType",
      "motorType",
      "flangeSize",
      "numberOfStacks",
      "nominalTorqueOfMotor",
      "continuousStallTorque",
      "peakStallTorque",
      "nominalSpeedOfMotor",
      "maximumMechanicalSpeed",
      "length",
      "motorSupplyVoltage",
      "shaftEnd",
      "ipProtections",
      "motorEncoder", // it's Feedback type
      "holdingBrake",
      "connector",
      "inertiaMotor",
      "motorWeight"
    ],
    deploy: false
  },
  {
    groupName: "gearbox",
    columns: [
      "gearboxReference",
      "gearboxComponentType",
      "gearboxType",
      "gearboxFamily", // Device short name
      "externalDiameter",
      "inputDiameter",
      "gearboxRatio",
      "gearboxEfficiency",
      "gearboxTorsionalBacklash",
      "shaftMomentOfInertia",
      "gearboxNetWeight",
      "gearboxLength"
    ],
    deploy: false
  },
  {
    groupName: "accessories",
    columns: ["adaptationKitRef", "adaptationKitComponentType", "separatePartDestination", "adaptationKitLength"]
  }
];

export const mobileDefaultColumns = [
  {
    groupName: "bundle",
    columns: [
      "nominalTorque",
      // "nominalTorqueUtilization",
      "nominalSpeed",
      // "nominalSpeedUtilization",
      "bundleInertia",
      "inertiaRatio",
      "length"
    ],
    deploy: true
  },
  {
    groupName: "drive",
    columns: ["driveReference"],
    deploy: false
  },
  {
    groupName: "motor",
    columns: ["motorReference"],
    deploy: false
  },
  {
    groupName: "gearbox",
    columns: ["gearboxReference"],
    deploy: false
  },
  {
    groupName: "accessories",
    columns: ["adaptationKitRef"],
    deploy: false
  }
];

// Personnalize columns
export const choosableColumns = [
  // Bundle columns
  "nominalTorque",
  "nominalTorqueUtilization",
  "nominalSpeed",
  "nominalSpeedUtilization",
  "bundleInertia",
  "inertiaRatio",
  "length",

  // Drive columns
  "driveReference",
  "driveRangeOfProduct",
  "driveType",
  "driveComponentType",
  "switchingFreq",
  "format",
  "current",
  "driveSupplyVoltage",
  "nbPhases",
  "interface",
  "nominalPower",
  "driveOutputCurrent3SPeak",
  "lineCurrent",
  "driveWidth",
  "driveHeight",
  "driveDepth",
  "driveNetWeight",

  // Motor columns
  "motorReference",
  "motorComponentType",
  "motorType",
  "flangeSize",
  "numberOfStacks",
  "nominalTorqueOfMotor",
  "continuousStallTorque",
  "peakStallTorque",
  "nominalSpeedOfMotor",
  "maximumMechanicalSpeed",
  "length",
  "motorSupplyVoltage",
  "shaftEnd",
  "shaftDiameter",
  "shaftLength",
  "ipProtections",
  "motorEncoder", // it's Feedback type
  "holdingBrake",
  "connector", // Electrical connection
  "inertiaMotor",
  "motorWeight",
  "continuousStallCurrent",
  "speedFeedbackResolution",
  "motorOutputCurrent3SPeak",

  // Gearbox columns
  "gearboxReference",
  "gearboxComponentType",
  "gearboxType",
  "gearboxFamily", // Device short name
  "externalDiameter",
  "inputDiameter",
  "gearboxRatio",
  "gearboxEfficiency",
  "gearboxTorsionalBacklash",
  "shaftMomentOfInertia",
  "gearboxNetWeight",
  "gearboxLength",
  "continuousOutputTorque",
  "maximumOutputTorque",
  "gearboxIpDegreeOfProtection",

  // Adaptation kit columns
  "adaptationKitRef",
  "adaptationKitComponentType",
  "separatePartDestination",
  "adaptationKitLength"
].sort();
